import { AutomatedForm } from './../../shared/models/solarForms.model';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, IAfterGuiAttachedParams } from 'ag-grid-community';

@Component({
  selector: 'app-cws-supplier-name',
  template: `
  <div class="row">
    <div class="col-12">{{params.value}}</div>
  </div>`,
  styleUrls: ['./cws-supplier-name.component.scss']
})
export class CwsSupplierNameComponent implements ICellRendererAngularComp {

  params: ICellRendererParams
  constructor(private router:Router,  private route: ActivatedRoute) { }
  refresh(params: ICellRendererParams): boolean {   
    return true
  }

  agInit(params: ICellRendererParams): void {   
    this.params=params;    
  }

}
